import { Box, Button, TextField, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const DocumentHeader = styled(Box)(({ theme }) => ({
	...flexMixin({ gap: 24 }),
	width: '100%',
	[theme.breakpoints.down('md')]: {
		gap: 16,
	},
	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
		gap: 12,
	},
}));

export const SearchField = styled(TextField)(({ theme }) => ({
	border: 'none',
	height: '44px',
	width: '100%',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	gap: '8px',

	'& fieldset': { border: 'none' },
	'& input': {
		padding: '10px 12px 10px 0',

		'&::placeholder': { color: '#8790A0', opacity: 1 },
	},
	[theme.breakpoints.down('sm')]: {
		height: '40px',
		'& input': {
			fontSize: '14px',
		},
	},
}));

export const AddDocumentButton = styled(Button)(({ theme }) => ({
	...flexMixin({ gap: 10 }),
	padding: '10px 16px',
	borderRadius: '8px',
	maxWidth: '210px',
	width: '100%',
	boxSizing: 'border-box',

	textTransform: 'unset',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: ' 157%',
	letterSpacing: '0.1px',
	color: '#4786FF',
	whiteSpace: 'nowrap',
	[theme.breakpoints.down('sm')]: {
		maxWidth: '100%',
		padding: '10px 12px',
		fontSize: '14px',
	},
}));

export const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});
